import type { CSSProperties } from "react";
import type { TradingPlatform } from "../../TradingBrowser";

export type FooterPanelTab =
  "terminal" | "scouts" | "changelog" | "errors" | "team" | "harper-ops";

export interface FooterToolbarProps {
  topStepXEnabled?: boolean;
  primaryPlatform?: TradingPlatform;
  onPrimaryPlatformChange?: (platform: TradingPlatform) => void;
  secondaryPlatform?: TradingPlatform;
  onSecondaryPlatformChange?: (platform: TradingPlatform) => void;
  splitViewEnabled?: boolean;
  onSplitViewToggle?: () => void;
  allowSplitView?: boolean;
  onPowerOff?: () => void;
  compactLevel?: 0 | 1 | 2;
  allowCustomIframes?: boolean;
}

export const FOOTER_BODY_FONT_STYLE: CSSProperties = {
  fontFamily: "var(--font-shell, Geist, Inter, var(--font-body))",
};

export const FOOTER_HEADING_FONT_STYLE: CSSProperties = {
  fontFamily: "var(--font-shell, Geist, Inter, var(--font-heading))",
};

export const FOOTER_DATA_FONT_STYLE: CSSProperties = {
  fontFamily: "var(--font-shell, Geist, Inter, var(--font-body))",
};
